import React, { useState } from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import OnboardStaff from './onboardStaff';
import OffboardStaff from './offboardStaff';

const SettingsModule = () => {
    const [showOnboardPopup, setShowOnboardPopup] = useState(false);
    const [showOffboardPopup, setShowOffboardPopup] = useState(false);
    return (
        <Container maxWidth="xl" sx={{ overflowY: 'hidden', display: 'flex', height: '100vh', justifyContent: 'stretch' }}>
            <Stack direction="column" sx={{ flex: 1 }}>
                <Stack direction="row" justifyContent="space-between">
                    {/* onChange={onSearchTextChange} value={filter} onKeyUp={searchKeyHandler}  */}
                    <Box sx={{ width: '300px' }}>
                        <Typography variant="h1">Settings</Typography>
                    </Box>
                </Stack>
                <Box>
                    <Stack direction="row" sx={{ gap: '16px' }}>
                        <Button
                            variant="contained"
                            sx={{ fontWeight: 'bold', alignSelf: 'center' }}
                            startIcon={<PersonAddAlt1Icon />}
                            onClick={() => setShowOnboardPopup(true)}
                        >
                            On-board Staff
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            sx={{ fontWeight: 'bold', alignSelf: 'center' }}
                            startIcon={<PersonRemoveIcon />}
                            onClick={() => setShowOffboardPopup(true)}
                        >
                            Off-board Staff
                        </Button>
                    </Stack>
                </Box>
                {showOnboardPopup && (
                    <OnboardStaff
                        show={showOnboardPopup}
                        handleClose={() => setShowOnboardPopup(false)}
                    />
                )}
                {showOffboardPopup && (
                    <OffboardStaff
                        show={showOffboardPopup}
                        handleClose={() => setShowOffboardPopup(false)}
                    />
                )}
            </Stack>
        </Container>
    )
}

export default SettingsModule;
